import {call, put, select, takeEvery} from "redux-saga/effects"

import api from "../../services/ApiService"
import {SearchCreators as Creators, SearchTypes as Types} from "./redux"
import {AppCreators} from "../App/redux"
import {i18n} from "../../utils"

export default function* router(dispatch, _action) {
  const state = yield select()
  const query = state.router.query.q

  // tracking
  yield put(
    AppCreators.trackingAdd({
      event: "mtm.virtualPageView",
      section: "search",
      search_phrase: typeof query !== "undefined" ? query : "",
      document_title:
        typeof query !== "undefined"
          ? `${i18n.t("Suche nach")} '${query}'`
          : i18n.t("Suche")
    })
  )

  // listen for search request
  yield takeEvery(Types.SEARCH_REQUEST, moreResults, dispatch)

  // trigger request
  if (typeof query !== "undefined") {
    yield put(Creators.request(query, 0, false))
  }

  // fetch knowledge tags initially
  try {
    const knowledgeTags = yield call(api.getKnowledgeTags, state.app.lang)

    yield put(Creators.knowledgeTags(knowledgeTags))
  } catch (e) {
    yield put(Creators.error(e.message))
  }
}

export function* moreResults(_dispatch, {slug, offset, append}) {
  const state = yield select()
  const lang = state.app.lang
  try {
    const searchResponse = yield call(
      api.getSearchedArticles,
      slug,
      offset,
      lang
    )

    yield put(
      Creators.success(
        searchResponse.results,
        searchResponse.query_vars,
        searchResponse.others,
        append
      )
    )

    // tracking (only for initial search requests)
    if (offset === 0) {
      yield put(
        AppCreators.trackingAdd({
          event: "mtm.searchExecuted",
          search_phrase: searchResponse.query_vars.s,
          number_of_results: searchResponse.query_vars.posts_found
        })
      )
    }
  } catch (e) {
    yield put(Creators.error(e.message))
  }
}



// WEBPACK FOOTER //
// ./src/containers/Search/sagas.js